import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query';
import {Campaign} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';

export interface UnpublishCampaignParams {
  id: string;
}

export const unpublishCampaign = async (params: UnpublishCampaignParams): Promise<Campaign> => {
  return await tinctApi.campaigns.unpublishCampaign(params.id);
};

export const useUnpublishCampaign = (
  options?: Omit<
    UseMutationOptions<Campaign, ApiError, UnpublishCampaignParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: unpublishCampaign,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
